import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {catchError, map, switchMap} from 'rxjs/operators';
import {
  getNotifications,
  getNotificationsSimple,
  loadNotificationsSuccess,
  upsertNotifications
} from './notification.actions';
import {DashboardService} from '../../dashboard/dashboard.service';
import {of} from 'rxjs';


@Injectable()
export class NotificationEffects {

  constructor(private actions$: Actions, private dashboardService: DashboardService) {
  }

  getNotifications$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(getNotifications),
      switchMap(action => this.dashboardService.getNotifications().pipe(map((notifications) => {
        return loadNotificationsSuccess({notifications});
      })))
    );
  });

  // getNotificationsSimple$ = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(getNotificationsSimple),
  //     switchMap(action => this.dashboardService.getNotificationsSimple().pipe(map((notifications) => {
  //       return loadNotificationsSuccess({notifications});
  //     })))
  //   );
  // });

  getNotificationsSimple$ = createEffect(() => {
    return this.actions$.pipe(
        ofType(getNotificationsSimple),
        switchMap(action =>
            this.dashboardService.getNotificationsSimple().pipe(
                map(notifications => loadNotificationsSuccess({ notifications })),
                catchError(error => {
                  if (error.status === 401) {

                  return of(loadNotificationsSuccess({ notifications: [] }));
                  }

                  return of(loadNotificationsSuccess({ notifications: [] }));
                })
            )
        )
    );
  });

}
